import { render, staticRenderFns } from "./OwnerCalculationForm.vue?vue&type=template&id=61887d60&scoped=true&"
import script from "./OwnerCalculationForm.vue?vue&type=script&lang=js&"
export * from "./OwnerCalculationForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerCalculationForm.vue?vue&type=style&index=0&id=61887d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61887d60",
  null
  
)

export default component.exports